/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Home_Artifacts_Chat_NameInputs */



/**
* | output |
* | --- |
* | "Chat about {count} artifacts" |
*
* @param {Home_Artifacts_Chat_NameInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const home_artifacts_chat_name = /** @type {((inputs: Home_Artifacts_Chat_NameInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Artifacts_Chat_NameInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Chat über ${i?.count} Artefakte`)
	return /** @type {LocalizedString} */ (`Chat about ${i?.count} artifacts`)
});